import { a as n } from "../../../chunk-OA3DH5LS-40f95340.js";
import { c as l } from "../../../index-34b1f277.js";
import { Dropdown as t } from "./Dropdown.es.js";
const a = n("LocationPickerAnatomy").parts(
  "buttonItem",
  "content",
  "item",
  "root"
), { defineMultiStyleConfig: r } = l(a.keys);
var e, o, i;
const m = r({
  baseStyle: {
    buttonItem: {
      ...(e = t.baseStyle) == null ? void 0 : e.buttonItem
    },
    content: {
      ...(o = t.baseStyle) == null ? void 0 : o.content
    },
    item: {
      ...(i = t.baseStyle) == null ? void 0 : i.item,
      height: "inherit",
      flexDirection: "column",
      gap: "2px",
      lineHeight: 1,
      textAlign: "left",
      b: {
        overflow: "hidden",
        display: "block",
        width: "100%",
        whiteSpace: "nowrap",
        fontWeight: 500,
        textOverflow: "ellipsis"
      },
      span: {
        overflow: "hidden",
        display: "block",
        width: "100%",
        whiteSpace: "nowrap",
        fontWeight: 400,
        textOverflow: "ellipsis"
      }
    },
    root: {}
  }
});
export {
  m as LocationPicker,
  a as LocationPickerAnatomy
};
//# sourceMappingURL=LocationPicker.es.js.map
